import TourismMapScreen from './TourismMapScreen';

/** Monday board view — שכבת יזמים from תיקי יזמים board (5097499192). */
export default function EntrepreneursMapScreen() {
  return (
    <TourismMapScreen
      fixedLayerId="entrepreneurs"
      title="מפת יזמים — גליל מזרחי"
      loadingLabel="טוען תיקי יזמים מ-Monday..."
    />
  );
}
